const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Size',
        dataIndex: 'size',
        render: defaultRender,
    },
    {
        title: 'Deleted Date',
        dataIndex: 'deletedDate',
        render: defaultRender,
    },
    {
        title: '',
        dataIndex: 'actions',
        render: defaultRender,
    },
];

export default columns;